import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  desc?: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({ title, desc, onReset, resetLabel = "重置筛选" }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-20 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-2xl text-secondary-600">
        <i className="ri-search-eye-line"></i>
      </div>
      <h3 className="text-lg font-semibold text-foreground-900">{title}</h3>
      {desc && <p className="mt-2 max-w-md text-sm text-foreground-600">{desc}</p>}
      <div className="mt-6 flex items-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-refresh-line"></i>
            {resetLabel}
          </button>
        )}
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}